import { render } from "./TeamsSelector.vue?vue&type=template&id=4ab6a428"
import script from "./TeamsSelector.vue?vue&type=script&lang=js"
export * from "./TeamsSelector.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__